import type { BaseServiceOptions, Pagination } from '@/core/types'
import {
  moduleServiceHandlers,
  serviceConfig,
  TInventoryHistories,
} from '../../..'
import { defaultPagination, useNotification } from '@/core'
import { useQuery } from '@tanstack/vue-query'
import { AxiosError } from 'axios'
const { details } = serviceConfig

export const useDetailsQuery = (options: BaseServiceOptions<Pagination>) => {
  const { currentPage, handlers, enableQuery, filters, modelId } = options
  const { errorHttpNotification } = useNotification()

  const loadDetails = useQuery<TInventoryHistories, AxiosError>({
    queryKey: [details, currentPage, filters?.loadDetails, modelId],
    queryFn: () =>
      moduleServiceHandlers.loadDetails({
        dynamicFilters: filters?.loadDetails,
        page: currentPage,
        modelId,
      }),
    onError: (error) => errorHttpNotification(error),
    enabled: enableQuery?.loadDetails,
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      if (data?.meta) {
        handlers?.onDataChange?.(data.meta ?? defaultPagination)
      }
    },
  })

  return {
    loadDetails,
  }
}
